<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title1">Acknowledgements</p>
<p class="noindent">Special thanks to Suzi Taylor, reference archivist (extraordinaire) at the Wyoming State Archives, for helping me solve a more than 125-year-old mystery surrounding Wyoming’s forgotten women’s militia. She patiently researched and scanned photographs and, at one time, literally shed some blood when she cut her finger pulling nails from an original solid wood backing (you could see the tree rings!) from a class of 1892 photograph because a spiderweb of dried masking tape obscured the image. And thank you to Jim Allison, Wyoming State Museum collection supervisor. I’ve known Jim since high school and recently discovered he is related to an original member of the Girl Guard. How cool is that? I am grateful for Jim sharing his family history in the foreword.</p>
<p class="indent">This manuscript is a culmination of more than eighteen months of research that included sifting through more than 1,600 firsthand documents and hundreds of photographs. That daunting task was made possible in large part by the Wyoming State Library, the Wyoming Newspaper Project, the Wyoming Genealogical Society, the Colorado Historic Newspaper Collection, the Library of Congress, Google Books and the National Archives. Photographs are courtesy of the Wyoming State Archives (WSA) unless otherwise noted. Artist renditions are by the author.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?48fe77e7